var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.453 6.51732C8.63385 6.50583 8.81623 6.5 8.99997 6.5C13.6944 6.5 17.5 10.3056 17.5 15C17.5 15.1837 17.4942 15.3661 17.4827 15.547C17.8086 15.4233 18.1229 15.276 18.4235 15.1071L20.9788 15.9589C21.5845 16.1608 22.1608 15.5845 21.9589 14.9788L21.1071 12.4235C21.6757 11.4114 22 10.2436 22 9C22 5.13401 18.866 2 15 2C12.0083 2 9.45485 3.87683 8.453 6.51732Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15C16 18.866 12.866 22 9 22C7.75644 22 6.58863 21.6757 5.57649 21.1071L3.02118 21.9589C2.41546 22.1608 1.83919 21.5845 2.0411 20.9788L2.89287 18.4235C2.32427 17.4114 2 16.2436 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15ZM6.5 15C6.5 14.4477 6.05228 14 5.5 14C4.94772 14 4.5 14.4477 4.5 15C4.5 15.5523 4.94772 16 5.5 16C6.05228 16 6.5 15.5523 6.5 15ZM10 15C10 14.4477 9.55228 14 9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16C9.55228 16 10 15.5523 10 15ZM12.5 16C13.0523 16 13.5 15.5523 13.5 15C13.5 14.4477 13.0523 14 12.5 14C11.9477 14 11.5 14.4477 11.5 15C11.5 15.5523 11.9477 16 12.5 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble26);
export default __webpack_public_path__ + "static/media/speech-bubble-26.15b51ae9107ed80cb7480d6953c716c9.svg";
export { ForwardRef as ReactComponent };